import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-100 d-flex align-items-center" }
const _hoisted_2 = {
  class: "info label-text",
  style: {"width":"92% !important"}
}
const _hoisted_3 = { class: "m-0" }
const _hoisted_4 = { class: "text-default label-text" }
const _hoisted_5 = ["onClick"]

import { TicketModule } from "@/store/modules/Ticket";
import { IdentificationModule } from "@/store/modules/Identification";
import IdentificationAdd from "./IdentificationAdd.vue";
import { computed, defineAsyncComponent, ref } from "vue";
import { coreApi } from "@/conection";
import { AlertModule } from "@/store/modules/Alert";


export default /*#__PURE__*/_defineComponent({
  props: {
    client: null,
    identifications: null
  },
  emits: ["deleted", "created"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "deleted", p: boolean): void;
	(e: "created", p: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	client?: string;
	identifications?: string[];
}

const MatchesModal = defineAsyncComponent(
	() => import("../../components/ticketSidebar/MatchesModal.vue")
);

// Emits

// Props


// Data
const modal = ref(false);
const deleteIdentification = ref(-1);
const addIdentification = ref(false);

// Computed
const ticket = computed(() => TicketModule.currentTicket);

// Methods
async function showModalCoincidences() {
	const payload = {
		client: props.client ?? ticket.value?.client[0]._id,
		identifications:
			props.identifications ?? ticket.value?.client[0].identification ?? [],
	};
	const response = await coreApi.post("/api/client/coincidences", payload);
	if (response.data.success) {
		IdentificationModule.setCoincidendes(response.data.coincidences);
		modal.value = true;
	} else
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: "No se han podido obtener las coincidencias!!!",
			type: "error",
		});
}

async function deleteIdentificatión(index: number) {
	const payload = {
		ticketID: props.client ? props.client : TicketModule.currentRoomID,
		client: props.client ?? TicketModule.currentTicket?.client[0]._id,
		identification: props.identifications?.length
			? props.identifications?.[index]
			: ticket.value?.client[0].identification[index],
	};
	const response = await coreApi.post<{
		success: boolean;
		coincidences: number;
	}>("/api/client/delete-identification", payload);
	if (response.data.success)
		IdentificationModule.setFoundCoincidences(response.data.coincidences > 0);
	emits("deleted", response.data.success);
}

function saveCoincidences(payload: {
	coincidences: number | undefined;
	identifier: string;
}) {
	emits("created", true);
	if (payload && payload.coincidences)
		IdentificationModule.setFoundCoincidences(
			IdentificationModule.FoundCoincidences || payload.coincidences > 0
		);
	addIdentification.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.identifications?.length || _unref(ticket)?.client[0].identification.length
						? "Identificadores:"
						: "Sin identificadores"), 1),
      (
					(__props.client?.length
						? __props.client?.length
						: !_unref(TicketModule).isOldTicket &&
							_unref(TicketModule).currentTicket?.client.length === 1) &&
						_unref(IdentificationModule).FoundCoincidences
				)
        ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 0,
            placement: "top",
            content: "Se encontraron coincidencias"
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: "fa fa-exclamation-triangle color-regular warning-button fa-xs text-center",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showModalCoincidences()))
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
					__props.client?.length ||
						(!_unref(TicketModule).isOldTicket &&
							_unref(TicketModule).currentTicket?.client.length === 1)
				)
        ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 1,
            placement: "bottom",
            content: "Añadir"
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: "fa fa-plus color-regular fa-xs add-button text-center",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (addIdentification.value = true))
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.identifications ??
					_unref(ticket)?.client[0].identification, (identificador, index) => {
        return (_openBlock(), _createBlock(_component_el_row, {
          key: index,
          onMouseenter: ($event: any) => (deleteIdentification.value = index),
          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (deleteIdentification.value = -1))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { class: "py-1 fs-base d-flex align-items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("li", _hoisted_4, _toDisplayString(identificador), 1),
                (
							__props.client?.length ||
								(!_unref(TicketModule).isOldTicket &&
									_unref(TicketModule).currentTicket?.client.length === 1 &&
									deleteIdentification.value === index)
						)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      placement: "bottom",
                      content: "Eliminar"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: "fa fa-trash color-regular fa-xs delete-button text-center",
                          onClick: ($event: any) => (deleteIdentificatión(index))
                        }, null, 8, _hoisted_5)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["onMouseenter"]))
      }), 128)),
      _createVNode(_component_el_row, { lass: "bg-white" }, {
        default: _withCtx(() => [
          (addIdentification.value)
            ? (_openBlock(), _createBlock(IdentificationAdd, {
                key: 0,
                client: __props.client,
                "ticket-id": __props.client ? __props.client : undefined,
                onShowIdentificationAdd: _cache[3] || (_cache[3] = payload => saveCoincidences(payload))
              }, null, 8, ["client", "ticket-id"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(MatchesModal), {
      open: modal.value,
      onChangeModal: _cache[4] || (_cache[4] = ($event: any) => (modal.value = false)),
      client: __props.client
    }, null, 8, ["open", "client"])
  ]))
}
}

})